import { useaxios } from "../../../utils/useaxios";
export default (from, to) => recaller => setrecaller => initDispatch => clear => settype => {
    useaxios('report/summary.php', { from, to }).then((res) => {
        console.log(res);

        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }

        if (res.status == "ok") {
            initDispatch({ type: 'setsummaryreport', payload: { summary_report_sell_array: res.data, summary_report_expense_amount: res.expense_amount, summary_report_damage_qty: res.damage_qty, summary_report_damage_amount: res.damage_amount, summary_report_return_item_company_qty: res.return_item_company_qty, summary_report_return_item_company_amount: res.return_item_company_amount, summary_report_total_service_price: res.total_service_price, summary_report_total_service_price_cash: res.total_service_price_cash, loan_out: res.loan_out, loan_out_discount: res.loan_out_discount, loan_in: res.loan_in, loan_in_discount: res.loan_in_discount, summary_report_total_return_price: res.total_return_price } });
            settype('summary');
            // setrecaller(recaller + 1);
        }
    });
}